import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import Utility from '../../../../../../../util/utilityfunctions';
import PropTypes from 'prop-types';
import {labels} from '../../../../../../../util/utils';
import BodySpecialAccordionContentList from '../BodySpecialAccordionContentList';
import ISA315ScotItApplicationAccordionItem from './ISA315ScotItApplicationAccordionItem';
import ControlsUnrelatedRow from './ControlsUnrelatedRow';

function ISA315ScotItAppCardItemContent({allItAppsIds, applicationControlIds, itdmControlIds, scotId}) {
	let itApps = useSelector((state) =>
		allItAppsIds.map((itAppId) => {
			return state.bodiesSpecial.itApplications.byId[itAppId];
		})
	);

	Utility.sortAlphaNumeric(itApps, 'itApplicationName');

	return (
		<StyledISA315ScotItAppCardItemContent className="StyledISA315ScotItAppCardItemContent">
			{(applicationControlIds.length > 0 || itdmControlIds.length > 0) && (
				<>
					{itApps && itApps.length > 0 ? (
						<StyledControlsWithNoItApps className="StyledControlsWithNoItApps">
							<ControlsUnrelatedRow
								key={`Unrelated-controls-${scotId}`}
								applicationControlIds={applicationControlIds}
								itdmControlIds={itdmControlIds}
							/>
						</StyledControlsWithNoItApps>
					) : (
						<ControlsUnrelatedRow
							key={`Unrelated-controls-${scotId}`}
							applicationControlIds={applicationControlIds}
							itdmControlIds={itdmControlIds}
						/>
					)}
				</>
			)}
			<BodySpecialAccordionContentList title={allItAppsIds.length > 0 && labels.itApplicationHeader}>
				{itApps.map((itApp, index) => {
					return (
						<ISA315ScotItApplicationAccordionItem
							key={`ItApp-${scotId}-${itApp.id}-${index}`}
							itAppId={itApp.id}
							scotId={scotId}
						/>
					);
				})}
			</BodySpecialAccordionContentList>
		</StyledISA315ScotItAppCardItemContent>
	);
}

ISA315ScotItAppCardItemContent.propTypes = {
	allItAppsIds: PropTypes.arrayOf(PropTypes.number),
	applicationControlIds: PropTypes.arrayOf(PropTypes.number),
	itdmControlIds: PropTypes.arrayOf(PropTypes.number),
	scotId: PropTypes.number
};

export default ISA315ScotItAppCardItemContent;

const StyledControlsWithNoItApps = styled.section`
	margin: 0 var(--px-17) 0 var(--px-43);
	border-bottom: var(--px-1) solid var(--neutrals-200);
`;

const StyledISA315ScotItAppCardItemContent = styled.section``;
